import { AppForm } from '../../../../../../../common/forms/app.form';
import { Injectable } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

@Injectable()
export class CoordinatingTrafficOrganizationProjectsInfoForm extends AppForm {

  public projectTypes: string[] = [
    'Stała organizacja ruchu',
    'Czasowa organizacja ruchu'
  ];

  constructor() {
    super({
      projectType: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(255)]
      }),
      taskName: new FormControl('', {
        nonNullable: true,
        validators: [Validators.maxLength(255)]
      }),
      shipmentContent: new FormControl('', {
        nonNullable: true,
        validators: [Validators.required, Validators.maxLength(5000)]
      }),
      description: new FormControl('', {
        nonNullable: true,
        validators: [Validators.maxLength(5000)]
      })
    });
  }
}
